import { api } from "../../utils/api";

export const patchCommissionsGeral = async (data) => {
  try {
    const response = await api.patch(`general-commission-settings`, data);
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.error.message);
  }
}
// http://sandbox.walletlote.app.br/api/documentation#/Contract/general-commission-settings